import restUtils from "core/utils/rest";

interface AmlRoleRow {
  roleType: string;
  description: string;
  roleSectionDesc: string;
  ptytyp: string;
  ptyMax: number;
  ptyMin: number;
  roleSequence: string | number;
}

interface RolesPayload {
  associatedGuidanceText: string;
  roles: AmlRoleRow[];
}

export interface EntityRoleModel {
  type: string;
  description: string;
  guidance: string;
  appliedTo: string;
  maxParty: number;
  minParty: number;
  order: number;
}

export function fetchEntityRoles(personId: string): Promise<{ guidanceText: string; roles: EntityRoleModel[] }> {
  return restUtils.call(
    "PortalApi",
    `hubwise-api/aml/investors/${personId}/roles`,
    "GET",
  ).then((payload) => {
    const p = payload as RolesPayload;
    return {
      guidanceText: p.associatedGuidanceText,
      roles: p.roles.map(dataToModel)
    };
  });
}

function dataToModel(row: AmlRoleRow): EntityRoleModel {
  return {
    type: row.roleType,
    description: row.description,
    guidance: row.roleSectionDesc,
    appliedTo: row.ptytyp,
    maxParty: row.ptyMax,
    minParty: row.ptyMin,
    order: Number(row.roleSequence)
  };
}
